// import { Spin } from 'antd'

// interface TableWrapperProps {
//   children: any
//   loading?: boolean
//   contentLoaderMode?: boolean
// }

// export default function TableWrapper({ children, loading = false, contentLoaderMode = true }: TableWrapperProps) {
//   return (
//     <div className="table-wrapper">
//       {contentLoaderMode ? (
//         <Spin spinning={false}>
//           {children}
//         </Spin>
//       ) : (
//         <Spin spinning={loading}>
//           {children}
//         </Spin>
//       )}
//     </div>
//   )
// }

import LoadingSpinner from '@components/LoadingSpinner'
import React from 'react'

interface TableWrapperProps {
  children: React.ReactNode
  loading?: boolean
  contentLoaderMode?: boolean
  hideScroll?: boolean
  maxHeight?: string | number
}

export default function TableWrapper({
  children,
  loading = false,
  contentLoaderMode = true,
  hideScroll = false,
}: TableWrapperProps) {
  return (
    <div
      className="table-wrapper"
      style={{
        ...(hideScroll && {
          overflow: 'auto',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }),
      }}
    >
      <LoadingSpinner
        spinning={contentLoaderMode ? false : loading}
        size="default"
      >
        {children}
      </LoadingSpinner>
    </div>
  )
}
